import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { resetFirstLastMargins } from '@/css/resources/placeholders.css';
import { transitions } from '@/css/resources/variables.css';
import {
	expandLink,
	fontStyle,
	fluidPadding,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidPadding(styles?.padding),
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,

			'.supt-cardFeature__text': fontStyle({
				...styles?.text?.typography,
				textAlign: styles?.text?.textAlignment,
				color: styles?.text?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'visible',
		position: 'relative',
		borderStyle: 'solid',

		'.supt-cardFeature__text': cssObj(resetFirstLastMargins, {
			'&.supt-cardFeature__link': {
				textDecoration: 'none',
			},
		}),

		/* with link */
		'&.supt-withLink': cssObj(expandLink(), {
			transition: `all ${transitions.mid} ease-out`,

			'.supt-cardFeature__text': {
				transition: `all ${transitions.mid} ease-out`,
			},

			'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
		}),
	});

// edit
const getEditGlobalStyles = (styles) =>
	cssObj({
		'.wp-block[data-type="supt/card-feature"]': {
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,

			'.supt-card': {
				height: '100%',
			},
		},
	});

export { getStyles, getEditGlobalStyles };
